// extracted by css-extract-rspack-plugin
export default {"button":"Z3EV7","root":"dazIA","open":"edmjL"};